import {RejectedTimelineEvent} from '@ots-frontend/ots-data';
import {Text, ThemeIcon} from '@mantine/core'
import {useTranslation} from "react-i18next";
import {FormattedDateTime} from '../../date/FormattedDateTime/FormattedDateTime';
import {IconThumbDownFilled} from "@tabler/icons-react";

type Props = {
    event: RejectedTimelineEvent;
};

export const RejectedTimelineItemTitle = (props: {}) => {
    const {t} = useTranslation(["common"])
    return <>{t("common.entity.dispatchrequest.timeline.rejected.title", "Rejected")}</>
}

export const RejectedTimelineItemBullet = (props: {}) => {
    return (
        <ThemeIcon
            size={22}
            color="dispatch-request-rejected"
            radius="xl"
        >
            <IconThumbDownFilled size={12}/>
        </ThemeIcon>
    )
}

export const RejectedTimelineItem = (props: Props) => {
    const {event} = props;

    const {t} = useTranslation(["common"])

    return (
        <>
            <Text color="dimmed" size="sm">
                {t("common.entity.dispatchrequest.timeline.rejected.summary", "{{personName}} rejected the dispatch request.", {
                    personName: event.person ? event.person : t("common.shared.user", "User")
                })}
            </Text>

            <Text size="xs" mt={4}>
                <FormattedDateTime date={event.date}/>
            </Text>
        </>
    );
};

RejectedTimelineItem.Title = RejectedTimelineItemTitle
RejectedTimelineItem.Bullet = RejectedTimelineItemBullet;
